import {useSelector} from 'react-redux';

const useGetMyCompanyId = ()=> {

  const user = useSelector((state=> state.user));
  return user.companyId;

};

export {useGetMyCompanyId};